<ng-container *ngIf="workflow$ | async as workflow">
    <a *ngIf="href$ | async as href"
       [routerLink]="href.path"
       [queryParams]="href.queryParams"
       [attr.data-tour]="'pathway-title-' + workflow.workflowId">{{workflow.name}}</a>
</ng-container>
